/// <reference path="../Helpers.js"/>

window.ChartSetupProxy = function () {

    function toIA(value) {
        if (!value)
            return [];

        if (typeof value === 'string')
            value = value.split(',');
        for (var i = 0; i < value.length; i++)
            value[i] = parseInt(value[i], 10);
        return value;
    }

    return {
        GetDefaultQuestions: function (calculationtype) {
            ChartSetupProxy.GetFilterQuestions("", calculationtype, "", "", "", false, "", 0, false, ChartSetupDataBinding.BindQuestions);
        },
        GetFilterQuestions: function (filter, calculationtype, questionBlocks, variableSubsets, gridQuestions, filterByCode, excludedQnTypes, maxNoOfAnswers, excludeNoDataQns, callback) {
            var data = {
                filterText: filter,
                calculationType: parseInt(calculationtype),
                questionBlocks: toIA(questionBlocks),
                variableSubsets: toIA(variableSubsets),
                gridQuestions: toIA(gridQuestions),
                optionalSettingsQuestions: Storyboard.ChartLab.optionalQuestions || toIA(""),
                extraQuestions: toIA(""),
                filterByCode: filterByCode,
                excludedQnTypes: toIA(excludedQnTypes),
                maxNoOfAnswers: maxNoOfAnswers,
                excludeNoDataQns: excludeNoDataQns
            };

            Helpers.perfJSonCall({ method: "FilterQuestions", message: "Loading variables", data: data, successCallback: callback, fixCasing: true });
        },
        GetFilterSelectedQuestions: function (filter, datagroup, filterByCode, callback) {
            var questions = datagroup.optionalChartSettings ? datagroup.optionalChartSettings.questions : null;
            var data = {
                filterText: filter,
                calculationType: datagroup.calculationType,
                questionBlocks: datagroup.questionSelections.questionBlocks,
                variableSubsets: datagroup.questionSelections.variableSubsets,
                gridQuestions: datagroup.questionSelections.gridQuestions,
                optionalSettingsQuestions: questions || toIA(""),
                extraQuestions: datagroup.questionSelections.questions,
                filterByCode: filterByCode,
                excludedQnTypes: toIA(""),
                maxNoOfAnswers: 0,
                excludeNoDataQns: false
            };

            Helpers.perfJSonCall({
                method: "FilterQuestions", data: data,
                successCallback: function (msg) { callback(msg, datagroup); },
                fixCasing: true
            });
        },
        GetTemplateData: function (templateDataGroupId, templateId, callback) {
            var data = {
                templateDataGroupId: templateDataGroupId,
                templateId: templateId
            };

            Helpers.perfJSonCall({
                method: "TemplateDataGroupData", data: data,
                successCallback: function (result) { callback(result); },
                fixCasing: true
            });
        },
        GetFilterQuestionsForCrossTable: function (filter, questionBlocks, variableSubsets, gridQuestions, optionalQuestions, calculationType, callback,
            extraQuestions, filterByCode, dgGroupedAnswers) {
            var data = {
                filterText: filter,
                questionBlocks: toIA(questionBlocks),
                variableSubsets: toIA(variableSubsets),
                gridQuestions: toIA(gridQuestions),
                optionalSettingsQuestions: optionalQuestions || toIA(""),
                calculationType: calculationType,
                extraQuestions: extraQuestions || toIA(""),
                filterByCode: filterByCode,
                dgGroupedAnswers: dgGroupedAnswers || null,
                fromWorkbook: false
            };

            Helpers.perfJSonCall({
                method: "FilterCrossTable2Questions",
                message: "Loading variables",
                data: data,
                successCallback: callback,
                fixCasing: true,
                keepUnusedDataFor: 60
            });
        },
        GetAnswers: function (selections, callback) {
            var data = {
                filterText: selections.filter,
                questionIDs: toIA(selections.selectedQuestions),
                variableSubsets: toIA(selections.variableSubsets),
                calculationType: parseInt(selections.calculationType),
				filterByRowNo: selections.filterByRowNo,
                checkCTFilterAR: selections.checkCTFilterAR || false,
                dgGroupedAnswers: selections.dgGroupedAnswers || null,
                hide999: selections.hide999 || false,
                skipGroupedAnswers: selections.skipNetGroupedAnswers || false
            };
            Helpers.perfJSonCall({
                method: "FilterAnswers",
                data: data,
                successCallback: callback,
                fixCasing: true,
                keepUnusedDataFor: 60
            });
		},
        GetSelectedAnswers: function (filterText, datagroup, filterByRowNo, callback) {
            var data = {
                filterText: filterText,
                questionIDs: datagroup.questionSelections.questions,
                variableSubsets: datagroup.questionSelections.variableSubsets,
                calculationType: datagroup.calculationType,
				filterByRowNo: filterByRowNo,
                checkCTFilterAR: false,
                dgGroupedAnswers: datagroup.groupedAnswers || null,
                hide999: datagroup.hide999 || false,
                skipGroupedAnswers: false
            };
            Helpers.perfJSonCall({
                method: "FilterAnswers",
                data: data,
                successCallback: callback,
                fixCasing: true,
                keepUnusedDataFor: 60
            });
        },
        SaveDataGroups: function (dataGroupList, deletedDataGroups, layoutElementItem, callback) {
            var data = {
                datagroups: dataGroupList,
                deletedGroups: deletedDataGroups,
                elementItem: layoutElementItem
            };
            Helpers.perfJSonCall({
                method: 'SaveDataGroups',
                service: 'chartsetup',
                data: data,
                successCallback: callback,
                fixCasing: true
			});
        },
        RHSaveDataGroups: function (dataGroupList, guid, callback) {
            var data = {
                datagroups: dataGroupList,
                guid: guid
            };
            Helpers.perfJSonCall({
                method: 'RHSaveDataGroups',
                service: 'chartsetup',
                data: data,
                successCallback: callback,
                message: 'Saving custom chart settings',
                fixCasing: true
			});
        },
        GetFilters: function (callback) {
            return Helpers.perfJSonCall({
                method: 'GetFilters',
                successCallback: callback,
                synchronous: false,
                fixCasing: true
            });
        },
        GetChartStyles: function (layoutElement, callback) {
            var data = {
                layoutElement: layoutElement,
                connString: ''
            }
            Helpers.perfJSonCall({
                method: "GetChartStyles",
                data: data,
                successCallback: callback,
                synchronous: false,
                fixCasing: false
            });
        },
        GetChartThemes: function (howMany, callback) {
            var data = {
                howMany: howMany
            };
            Helpers.perfJSonCall({
                method: "GetChartThemes",
                data: data,
                successCallback: callback,
                fixCasing: false
            });
        },
        GetThemeStyles: function (themeID, callback) {
            var data = {
                themeID: themeID
            }
            Helpers.perfJSonCall({
                method: "GetThemeStyles",
                data: data,
                successCallback: callback,
                fixCasing: false
            });
        },
        GetPreviewChart: function (params, loadingMessage, callback) {
            Helpers.perfJSonCall({
                method: 'GetChart',
                data: params,
                successCallback: callback,
                service: 'chartsetup',
                message: loadingMessage
            });
        },
        GetSimpleTable: function (data, callback) {
            Helpers.perfJSonCall({
                method: 'GetSimpleTable',
                data: data,
                successCallback: callback
            });
        },
        LoadScatterOptions: function (dataGroups, callback) {
            Helpers.perfJSonCall({
                method: 'LoadScatterOptions',
                data: { dataGroups: dataGroups },
                service: 'chartsetup',
                successCallback: callback,
                message: 'Loading scatter series'
            });
        },
        GetAllowZoomDefaultSetting: function (callback) {
            Helpers.perfJSonCall({
                method: 'ZoomDefaultSetting',
                service: 'chartsetup',
                successCallback: callback,
                message: 'Loading chart zoom deafult setting',
                failCallback: function () {
                    console.log('fail');
                }
            });
        },
        GetAllowZoomSetting: function (layoutElementItem, callback) {
            Helpers.perfJSonCall({
                method: 'GetDataGroupsForLayoutElementItem',
                data: {
                    elementItem: layoutElementItem,
                    area: 'chartsetup',
                    part: ""
                },
                service: 'chartsetup',
                successCallback: callback,
                failCallback: function () {
                    console.log('fail');
                }
            });
        },
        GetDecimalOperator: function (callback) {
            Helpers.perfJSonCall({
                method: 'DeafultDecimalSeparator',
                service: 'chartsetup',
                successCallback: callback
            });
        },
        GetCTFavorites: function (templatesOnly, callback) {
            Helpers.perfJSonCall({
                data: {
					templatesOnly: templatesOnly
                },
                method: "LoadAvailableFavorites",
                service: "CrossTableSetup",
                successCallback: callback,
                fixCasing: true
            });
		},
		GetCTWorbooks: function (callback) {
			Helpers.perfJSonCall({
				method: "LoadAvailableWorkbooks",
				service: "CrossTableSetup",
				successCallback: callback,
				fixCasing: true
			});
		},
        GetDefaultSigTestIcons: function (callback) {
            Helpers.perfJSonCall({
                method: "GetDefaultSigTestIcons",
                service: "chartsetup",
                successCallback: callback,
                fixCasing: true
            });
        },
        ExportObject: function (params, callback) {
            Helpers.perfJSonCall({
                data: params,
                method: "DownloadObjectExport",
                message: "Preparing download",
                successCallback: callback,
                fixCasing: true
            });
        }
    };
}();

